import styled from 'styled-components';

import { colors } from 'global/colors';
import { Link as BaseLink } from '../../components';

export const Link = styled(BaseLink)`
  font-size: 14px;
  margin-bottom: 10px;
  color: ${colors.darkBlue};

  :hover {
    color: ${colors.green};
  }

  :last-child {
    margin-bottom: 0;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
`;
